import * as types from '../actions/types'

const initialState = {
  meta: {},
  isPlaying: false,
  elapsed: null,
  didSeek: false,
  volume: 0.85
}

export default function (state=initialState, action) {

  switch (action.type) {
    case types.LOAD_TRACK:
      return Object.assign({}, state, {
        meta: action.track,
        isPlaying: false,
        elapsed: 0,
        didSeek: false
      })

    case types.TOGGLE_CURRENT_TRACK:
      return Object.assign({}, state, {
        isPlaying: (action.force === undefined) ? !state.isPlaying : action.force
      })

    case types.TICK_CURRENT_TRACK:
      if (state.isPlaying === false)
        return state

      return Object.assign({}, state, {
        elapsed: action.tick
      })

    case types.SEEK_CURRENT_TRACK:
      return Object.assign({}, state, {
        elapsed: action.time,
        didSeek: true
      })

    // Called to unset the didSeek property
    case types.UNSEEK_CURRENT_TRACK:
      return Object.assign({}, state, {
        didSeek: false
      })

    case types.SET_VOLUME:
      return Object.assign({}, state, {
        volume: action.volume
      })

    default:
      return state
  }
}

// {...state, isPlaying: true} is same as:
// Object.assign({}, state, {
//   isPlaying: true
// })



// WEBPACK FOOTER //
// ./src/reducers/currentTrack.js